import React from 'react'
import { Container, Row, Col, Input, Button, Label } from 'reactstrap';
import BOTechnologyRequests from '../components/Reports/BOTechnologyRequests';
import CompanyDateToDate from '../components/Reports/CompanyDateToDate';
import CustomerInfoListing from '../components/Reports/CustomerInfoListing';
import CustomerManagement from '../components/Reports/CustomerManagement';
import CustomerMeetings from '../components/Reports/CustomerMeetings';
import CustomerWorkflowDetail from '../components/Reports/CustomerWorkflowDetail';
import CustomerWorkflowsManagementStyle from '../components/Reports/CustomerWorkflowsManagementStyle';
import CustomerListing from '../components/Reports/CustomerListing';
import IndividualResponsibilities from '../components/Reports/IndividualResponsibilities';
import MorningBandwidth from '../components/Reports/MorningBandwidth';
import MorningBandwidth2 from '../components/Reports/MorningBandwidth2';
import TeamResponsibilities from '../components/Reports/TeamResponsibilities';
import EmployeeCustomerListing from '../components/Reports/EmployeeCustomerListing';
import EmployeeManager from '../components/Reports/EmployeeManager';
import RevenueComparison from '../components/Reports/RevenueComparison';
import EmployeeStartTimesDateToDate from '../components/Reports/EmployeeStartTimesDateToDate';
import EmployeeTimeTracking from '../components/Reports/EmployeeTimeTracking';
import WorkflowManagement from '../components/Reports/WorkflowManagement';
import * as XLSX from "xlsx";
import { CSVLink } from "react-csv";
import 'bootstrap/dist/css/bootstrap.css';

//const testData = require('./TestData.js');

class Reports extends React.Component {

    constructor(props) {
        super(props);

        this.path = String(this.props.location.pathname).split('/');
        if (this.path[3] != null) {
            this.path[3] = this.path.filter((i, index) => index > 2).join('/');
        }

        let state = {
            ...this.state,
            reportId: -1,
            sheetData: [],
            fileName: '',
            path: '',
            title: '',
            selector: this.path[3] != null ? this.path[3] : null,
            reports: [],
            filterClients: []
        };

        let sel = {
            Unset: true
        };
        this.activeServices = ['Unset'];
        this.props.clients.forEach(client => {
            client.services.filter(service => service.active).forEach(service => {
                if (this.activeServices.findIndex(item => item === service.name) === -1) {
                    this.activeServices.push(service.name);
                    sel[this.getLetters(service.name)] = true;
                }
            });
        });
        this.activeServices.sort();
        this.state = { ...state, filterServices: sel };
    }

    componentDidMount = () => {
        this.props.log('Reports.js/componentDidMount');
        this.reports = [
            {
                id: 0, title: 'Company Date to Date Recon Status', path: 'company-date-to-date-recon-status', activeServices: true, type: 'Detail Reports', module:
                    <CompanyDateToDate {...this.props} passData={this.passData} changeSelector={this.onChangeSelector} selector={this.state.selector} 
                    filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback} />
            },
            {
                id: 1, title: 'Customer Info Listing', path: 'customer-info-listing', activeServices: true, type: 'Detail Reports', module:
                    <CustomerInfoListing {...this.props} passData={this.passData} changeSelector={this.onChangeSelector} selector={this.state.selector} 
                    filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback} />
            },
            {
                id: 2, title: 'Customer Management Report', path: 'customer-management-report', type: 'Management Reports', module:
                    <CustomerManagement {...this.props} passData={this.passData} />
            },
            {
                id: 3, title: 'Customer Workflow Detail', path: 'customer-workflow-detail', type: 'Detail Reports', activeServices: true, module:
                    <CustomerWorkflowDetail {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector}
                    filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}  />
            },
            {
                id: 4,  title: 'Customer Workflows Management Style', path: 'customer-workflows-management-style', type: 'Detail Reports', activeServices: true, module:
                    <CustomerWorkflowsManagementStyle {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector}
                    filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback}  />
            },
            {
                id: 5, title: 'Customer Listing', path: 'customer-listing', type: 'Management Reports', module:
                    <CustomerListing {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 6, title: 'Employee Customer Listing', path: 'employee-customer-listing', type: 'Management Reports', module:
                    <EmployeeCustomerListing {...this.props} passData={this.passData} />
            },
            {
                id: 7, title: 'Employee Manager Report', path: 'employee-manager-report', type: 'Management Reports', module:
                    <EmployeeManager {...this.props} passData={this.passData} />
            },
            {
                id: 8, title: 'Individual Responsibilities', path: 'individual-responsibilities', type: 'Detail Reports', module:
                    <IndividualResponsibilities {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 9, title: 'Revenue Comparison', path: 'revenue-comparison', type: 'Detail Reports', activeServices: true, module:
                    <RevenueComparison {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} 
                    filterClients={this.getFilterClients} filterClientsCallback={this.filterClientsCallback} />
            },
            {
                id: 10, title: 'Team Responsibilities', path: 'team-responsibilities', type: 'Management Reports', module:
                    <TeamResponsibilities {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 11, title: 'Employee Start Times', path: 'employee-start-times', type: 'Detail Reports', module:
                    <EmployeeStartTimesDateToDate {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 12, title: 'Morning Bandwidth', path: 'morning-bandwidth', type: 'Management Reports', module:
                    <MorningBandwidth {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 13, title: 'Workflow Management', path: 'workflow-management', type: 'Management Reports', module:
                <WorkflowManagement {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 14, title: 'Employee Time Tracking', path: 'employee-time-tracking', type: 'Detail Reports', module:
                <EmployeeTimeTracking {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 15, title: 'Customer Meetings', path: 'customer-meetings', type: 'Management Reports', module:
                <CustomerMeetings {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 16, title: 'Morning Bandwidth 2', path: 'morning-bandwidth-2', type: 'Management Reports', module:
                    <MorningBandwidth2 {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
            {
                id: 17, title: 'BO Technology Requests', path: 'bo-technology-requests', type: 'Management Reports', module:
                    <BOTechnologyRequests {...this.props} changeSelector={this.onChangeSelector} passData={this.passData} selector={this.state.selector} />
            },
           
        ];
        this.reportIndex = (this.path[2] != null) ? this.reports.findIndex(report => report.path === this.path[2]) : -1;
        this.setState({
            reportId: (this.path[2] != null && this.reportIndex > -1) ?
                this.reportIndex : -1,
            reports: this.reports,
            path: this.reportIndex > -1 ? this.reports[this.reportIndex].path : '',
            title: this.reportIndex > -1 ? this.reports[this.reportIndex].title : ''
        }, () => this.filterClients())
    }

    checkPermission = (permission) => {
        this.props.info('Reports.js/checkPermission (permission)', permission);
        const permissionGranted =
            permission === '' || permission == null ||
            this.props.userPermissions.findIndex(i => i.toUpperCase() === permission.toUpperCase()) > -1;
        return permissionGranted;
    }

    filterClientsCallback = (cb) => {
        this.props.log('Reports.js/filterClientsCallback (cb)', cb);
        this.setState({
            filterClientsCallback: cb
        });
    }

    onChange = (e) => {
        this.props.log('Reports.js/onChange (name, value, e)', e.target.name, e.target.value, e);
        e.persist();
        this.props.ping();
        this.setState({
            sheetData: [],
            fileName: '',
            reportId: e.target.value,
            path: (e.target.value >= 0) ? this.state.reports[e.target.value].path : '',
            title: (e.target.value >= 0) ? this.state.reports[e.target.value].title : '',
            selector: null
        }, () => this.setLocation());
    }

    onChangeSelector = (e) => {
        this.props.log('Reports.js/onChangeSelector (name, value, e)', e.target.name, e.target.value, e);
        const xe = { ...e };
        this.setState({
            selector: (xe.target.value !== '' && xe.target.value != null) ? xe.target.value : null
        }, () => { this.setLocation(); this.filterClients(); });
    }

    setLocation = () => {
        this.props.log('Reports.js/setLocation');
        window.history.pushState({}, this.state.title, '/reports/' + this.state.path + (this.state.selector != null ? '/' + this.state.selector : ''))
    }

    getFilterClients = () => {
        this.props.log('Reports.js/getFilterClients');
        return this.state.filterClients;
    }

    onlySelect = (service) => {
        this.props.log('Reports.js/onlySelect (service)', service);
        let sel = { ...this.state }.filterServices;
        Object.keys(this.state.filterServices).forEach(key => {
            sel[key] = false;
        });
        sel[service] = true;
        this.setState(sel, () => this.filterClients());
    }

    passData = (data, fileName) => {
        this.props.log('Reports.js/passData (data, fileName)', data, fileName);
        this.setState({
            sheetData: data,
            fileName: fileName
        });
    }

    filterClients = () => {
        this.props.log('Reports.js/filterClients');
        this.setState({
            filterClients: this.props.clients.filter(client => client.active === true && (
                (client.services.filter(service => service.active).map(service => this.getLetters(service.name))
                    .findIndex(service => this.state.filterServices[service]) > -1) ||
                (this.state.filterServices.Unset &&
                    client.services.filter(service => service.active).length === 0)
            ))
        }, () => { if (this.state.filterClientsCallback) this.state.filterClientsCallback(); });
    }

    getLetters = (str) => {
        this.props.info('Reports.js/getLetters (str)', str);
        return str.replace(/[^a-zA-Z]+/g, '');
    }

    displayReport = () => {
        this.props.info('Reports.js/displayReport');
        return (this.state.reportId >= 0 && this.checkPermission(this.state.reports[this.state.reportId].title)) ? this.state.reports[this.state.reportId].module : (<>None</>);
    }

    handleExport = () => {
        this.props.log('Reports.js/handleExport (dataGrid, documentName, schema, documentId)');
        const dataGrid = [{ data: [], tab: "Report" }];
        const exportGrid = dataGrid.map(tab => {
            tab.data =
                this.state.sheetData.map(row => row.map(col => { return col }));
            return tab;
        })
        let wb = XLSX.utils.book_new();
        exportGrid.forEach((tab) => {
            let ws = XLSX.utils.aoa_to_sheet(tab.data);
            XLSX.utils.book_append_sheet(wb, ws, tab.tab);
        })
        const d = new Date();
        XLSX.writeFile(wb, "rbo-report_" + this.state.fileName + '_' + (d.getMonth() + 1) + '-' + d.getDate() + '-' + d.getFullYear() + '.xlsx')
    }

    render = () => {
        this.props.info('Reports.js/render');
        return (
            <>
                <Container fluid>
                    <Row className="noPrint px-2">
                        <Col md={5}>
                            <Input type="select" name="report" value={this.props.isFieldNull(this.state.reportId)} onChange={(e) => this.onChange(e)}>
                                <option value="-1">Select Report</option>
                                {['Management Reports','Detail Reports'].map(type => (
                                    <optgroup key={type} label={type}>
                                        {this.state.reports.filter(report => report.type === type && this.checkPermission(report.title)).sort((a,b) => a.title.localeCompare(b.title)).map((report) => (
                                            <option key={report.id} value={this.props.isFieldNull(report.id)}>{report.title}</option>
                                        ))}
                                    </optgroup>
                                ))}
                            </Input>
                        </Col>
                        <Col md={7} className="text-right">
                            {this.state.sheetData.length > 0 ?
                                <>
                                    <Button onClick={() => window.print()} color="primary">Print</Button>
                                    <Button onClick={() => this.handleExport()} color="primary">Download XLSX</Button>
                                    <CSVLink
                                        className="btn btn-primary"
                                        data={this.state.sheetData}
                                        filename={"rbo-report_" + this.state.fileName + ".csv"}
                                    >Download CSV</CSVLink></>
                                : <></>}
                        </Col>
                    </Row>
                    {parseInt(this.state.reportId) >= 0 && this.reports[parseInt(this.state.reportId)].activeServices ?
                        <Row className="text-left py-2 font-weight-bold">
                            <Col md={12}>
                                {this.activeServices.map(service => (
                                    <div key={service} className="px-4 pull-left d-inline-block">
                                        <Label><Input
                                            type="checkbox"
                                            name={this.getLetters(service)}
                                            checked={this.props.isFieldNull(this.state.filterServices[this.getLetters(service)],true)}
                                            onChange={() => this.setState((prevState) => {
                                                let sel = prevState.filterServices;
                                                sel[this.getLetters(service)] = !this.state.filterServices[this.getLetters(service)];
                                                return sel;
                                            }, () => this.filterClients())}
                                        /> {service}</Label><span onClick={() => this.onlySelect(this.getLetters(service))} className="pull-left px-2 onlySelect">Only</span>
                                    </div>
                                ))}
                            </Col>
                        </Row> : <></>}
                    <Row className="mainRow px-3 mt-3 text-left scrollH">
                        <Col md={12}>
                            {this.displayReport()}
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default Reports;